import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import screenfull from 'screenfull';

import {BrandingComponent} from '../widgets/branding.component';
import {GithubButtonComponent} from '../widgets/github.component';
import {NotificationComponent} from '../widgets/notification.component';
import {TranslateComponent} from '../widgets/translate.component';
import {UserComponent} from '../widgets/user.component';
import {Router, RouterLink} from "@angular/router";
import {SessionManager} from "../../manager/SessionManager";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    BrandingComponent,
    GithubButtonComponent,
    NotificationComponent,
    TranslateComponent,
    UserComponent,
    RouterLink,
    NgIf,
  ],
  providers: [SessionManager]
})
export class HeaderComponent {
  @HostBinding('class') class = 'matero-header';

  @Input() showToggle = true;
  @Input() showBranding = false;

  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleSidenavNotice = new EventEmitter<void>();

  constructor(private sessionManager: SessionManager,
              private router: Router) {
  }

  isAuth() {
    return this.sessionManager.isAuth()
  }

  name() {
    return this.sessionManager.name()
  }

  toggleFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }

  exit() {
    this.sessionManager.clear()
    this.router.navigateByUrl("/auth/login")
  }
}
